import MarcaYrm from './MarcaYrm'
import * as S from './styles'

// compacto: dentro de cartões e painéis. flutuante: sobre uma tela já desenhada,
// sem tirar o conteúdo do lugar, e só aparece se a espera passar de 250 ms.
function Loader({ texto = 'Carregando', compacto = false, flutuante = false }) {
  return (
    <S.Loader className='yrm-loader' role='status' aria-label={texto} $compacto={compacto} $flutuante={flutuante}>
      <MarcaYrm />
      <span className='texto'>{texto}</span>
    </S.Loader>
  )
}

export default Loader
